export const FOLDER_NEXT_STATES_LIST_COMPUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderNextStatesListComputed";
export const FOLDER_NEXT_STATES_LIST_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderNextStatesListInvalidated";
export const FOLDER_STATE_UPDATED = "Charisma.Leasing.PublishedLanguage.Events.LeasingFolder.FolderStateUpdated";
